<label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
<span class="b-f-textboxwithcopy">
  <input
    type="text"
    autocomplete="off"
    class="{{ !!formControl.value ? 'p-filled' : '' }}"
    [id]="field.id"
    pInputText
    [placeholder]="props.placeholder"
    [formControl]="formControl"
    [formlyAttributes]="field"
    #formlink
  />
  <button
    pButton
    pRipple
    type="button"
    (click)="copyInputMessage(formlink)"
    icon="icon-content-copy"
    class="p-button-rounded p-button-text"
  ></button>
</span>
